export class NavigationService {

  isNavigationMenuDarkMode = false;

  isHamburgerMenuOpen = false;
}
